import { forwardRef } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';

import { Spinner } from '../icons';

interface Props extends ButtonProps {
  isDisabledWhenLoading?: boolean;
  loading?: boolean;
}

const styles = {
  icon: {
    animation: 'rotation 1s linear infinite',
    transformOrigin: 'center',

    '@keyframes rotation': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '50%': {
        transform: 'rotate(180deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  },
};

export const LoadingButton = forwardRef<HTMLButtonElement, Props>(
  function LoadingButton(
    { disabled, isDisabledWhenLoading = true, loading, startIcon, ...rest },
    ref,
  ) {
    return (
      <Button
        {...rest}
        ref={ref}
        disabled={isDisabledWhenLoading ? loading || disabled : disabled}
        startIcon={loading ? <Spinner sx={styles.icon} /> : startIcon}
      />
    );
  },
);
